// extracted by mini-css-extract-plugin
export default {"full":"MainScreen_full__RIwos","content":"MainScreen_content__CQ6Na"};